"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  baseUnit: 16,
  // TODO: analog EM for sizing
  baseSpace: 4
};
exports["default"] = _default;